import {useDispatch, useSelector} from "react-redux";
import {GET_PAYMENT_STEP, SET_PAYMENT_STEP} from "@/store/slices/appSlice";
import {SET_PAYMENT_METHOD} from "@/store/slices/paymentSlice";
import CartaoCredito from "@/features/Pagamentos/CartaoCredito";
import DebitoEmConta from "@/features/Pagamentos/DebitoEmConta";
import ButtonPayments from "@/components/inputs/buttonPayments";
import {GET_OFFER_TYPE} from "@/store/slices/offerSlice";
import {AppEnum} from "@/enums/AppEnum";
import { useCookies } from "react-cookie"
import CardFlagIcon from "@/components/CardFlagIcon";

import Events from "@/utils/Events";
import { GET_USER } from "@/store/slices/userSlice";

const Pagamentos = () => {
    const USER = useSelector(GET_USER)
    const [cookies] = useCookies(['OESP_INFO']);
    const events = new Events();
    const offer_type = useSelector(GET_OFFER_TYPE)
    const dispatch = useDispatch();
    const PAYMENT_TAB = useSelector(GET_PAYMENT_STEP)
    
    function setTab(idx: number) {
        switch (idx) {
            case 0:
                dispatch(SET_PAYMENT_METHOD('cc'));
                break;
            case 1:
                dispatch(SET_PAYMENT_METHOD('dc'))
                break;
            case 2:
                dispatch(SET_PAYMENT_METHOD('paypal'))
                break;
        }
        dispatch(SET_PAYMENT_STEP(idx))
    }

    function returnTab() {
        switch (PAYMENT_TAB) {
            case 0:
                return <CartaoCredito></CartaoCredito>
            case 1:
                return <DebitoEmConta></DebitoEmConta>
            case 3:
                return
            case null:
                return <></>;
        }
    }

    return (
        <>
            {/* {oferta?.forma_pagamento?.credito &&  */}
                <ButtonPayments onClick={() => {
                    events.trigger("metodo_pagamento_cartao", { offer_type })
                    setTab(0)
                }}
                  forma={'cc'}
                  label="Cartão de Crédito"
                  >
                    <CardFlagIcon flag="VISA" />
                    <CardFlagIcon flag="CRED" />
                    <CardFlagIcon flag="AMEX" />
                    <CardFlagIcon flag="DINN" />
                    <CardFlagIcon flag="ELO" />
                    <CardFlagIcon flag="HIPE" />
                    {returnTab()}
                </ButtonPayments>
            {/* } */}
            
            { offer_type?.toString().includes('impresso') && /*oferta?.forma_pagamento?.debito &&*/
                <ButtonPayments onClick={() => {
                    events.trigger("metodo_pagamento_debito", { offer_type })
                    setTab(1)
                }} forma={'dc'} label={'Débito em conta Bradesco'}>
                    {returnTab()}
                </ButtonPayments>
            }
            {AppEnum.PAYPAL_HABILITADO && <ButtonPayments onClick={() => {
                events.trigger("metodo_pagamento_paypal", { offer_type })
                setTab(2)
            }} forma={'paypal'} label={'Paypal'}>
                {returnTab()}
            </ButtonPayments>}

        </>
    )
}

export default Pagamentos